import axios from 'axios';
import { ACCESS_TOKEN, AUTH, MESSAGE, USER_SESSION } from '../assets/constants';

const baseURL = process.env.REACT_APP_API_URL || process.env.VITE_API_URL || process.env.NEXT_PUBLIC_API_URL || 'http://localhost:8091';

const apiClient = axios.create({
    baseURL,
    headers: {
        Accept: 'application/vnd.certuit-v1.0.0+json',
        'Content-Type': 'application/json'
    }
});

apiClient.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem(ACCESS_TOKEN);
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

let isLoggingOut = false;

const handleSessionExpired = () => {
    if (isLoggingOut) return;
    isLoggingOut = true;

    console.warn('🔐 Sesión expirada');

    window.dispatchEvent(new Event('session-expired'));
};

apiClient.interceptors.response.use(
    (response) => {
        // 🔥 también validar respuestas exitosas con error lógico
        const message = response?.data?.message || '';

        if (
            response?.data?.success === false &&
            (message.includes('Expired JWT') || message.includes('UserPrincipal') || message.includes('token'))
        ) {
            handleSessionExpired();
            return Promise.reject(response);
        }

        return response;
    },
    (error) => {
        const status = error?.response?.status;
        const message = error?.response?.data?.message || '';

        if (status === 401 || message.includes('Expired JWT') || message.includes('UserPrincipal')) {
            handleSessionExpired();
        }

        return Promise.reject(error);
    }
);

export default apiClient;
